import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import { allPricesAreNotLabels } from '../../../../modules/money/services/price';
import { formatCurrency, isPriceLabel } from '../../../../utils/currency/currency';
export function formatServiceOutput() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    duration = _ref.duration,
    _ref$durationUnit = _ref.durationUnit,
    durationUnit = _ref$durationUnit === void 0 ? '' : _ref$durationUnit;
  var durationUnitByIso = {
    seconds: 'SEC',
    minutes: 'MIN',
    hours: 'HUR',
    days: 'DAY',
    weeks: 'WKE',
    months: 'MON',
    years: 'YEA'
  };
  var durationUnitIso = durationUnitByIso[durationUnit.toLowerCase()];
  if (_isNil(duration) || _isNil(durationUnitIso)) {
    return {};
  }
  return {
    '@type': 'QuantitativeValue',
    value: duration,
    unitCode: durationUnitIso
  };
}
export function formatServiceOffers() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$prices = _ref2.prices,
    prices = _ref2$prices === void 0 ? [] : _ref2$prices;
  if (_isEmpty(prices)) {
    return {};
  }
  var singlePrice = prices.length === 1;
  if (singlePrice) {
    var price = prices[0];
    if (!isPriceLabel(price)) {
      return {
        '@type': 'Offer',
        price: formatCurrency(+price, 2, {
          hideCurrencySign: true
        }),
        priceCurrency: 'USD'
      };
    }
  }
  if (!singlePrice && allPricesAreNotLabels(prices.map(function (price) {
    return {
      amount: price
    };
  }))) {
    return {
      '@type': 'AggregateOffer',
      priceCurrency: 'USD',
      offerCount: prices.length,
      lowPrice: formatCurrency(Math.min.apply(Math, _toConsumableArray(prices.map(function (price) {
        return +price;
      }))), 2, {
        hideCurrencySign: true
      }),
      highPrice: formatCurrency(Math.max.apply(Math, _toConsumableArray(prices.map(function (price) {
        return +price;
      }))), 2, {
        hideCurrencySign: true
      })
    };
  }
  return {};
}